import { render, staticRenderFns } from "./Schedule.vue?vue&type=template&id=0b531a1d&scoped=true"
import script from "./Schedule.vue?vue&type=script&lang=js"
export * from "./Schedule.vue?vue&type=script&lang=js"
import style0 from "./Schedule.vue?vue&type=style&index=0&id=0b531a1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b531a1d",
  null
  
)

export default component.exports